<template>
    <div class="component-tab-menu">        
        <PTabMenu style="width: 100%;" :model="itemsAtivos" @tabChange="tabChange" :activeIndex="itemAtivo"> 
        </PTabMenu>
    </div>
 
    <router-view @change="verificaRoute" v-slot="{Component}">
            <component  :is="Component" v-model="teste" :key="$route.name" v-if="!$route.meta.keepAlive"/>
    </router-view>
</template>

<script>
import gTabMenu from './g-tab-menu.js'
export default gTabMenu 
</script>

<style scoped>
.component-tab-menu {
    margin: 20px 20px 0 20px;
    display: flex;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

:deep(.p-component) {
    border-radius: 10px;
}

:deep(.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link), :deep(.p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link) {
    border-color: #4f2c19;
    color: #4f2c19;
}

:deep(.p-tabmenu-nav .p-menuitem-text) {
    font-family: "MontSerrat";
    font-size: 15px;
}

:deep(.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link) {
    color: #8a8a8a;
    font-weight: 500;
    border: solid #f0f0f0;
    border-width: 0 0 2px 0;
}

:deep(.p-tabmenu .p-tabmenu-nav) {
    border: solid #f0f0f0;
    border-width: 0 0 2px 0
}

:deep(.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus) {
    box-shadow: none;
}
</style>
